import { render, staticRenderFns } from "./BotView.vue?vue&type=template&id=777f8ff8&scoped=true"
import script from "./BotView.vue?vue&type=script&lang=js"
export * from "./BotView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777f8ff8",
  null
  
)

export default component.exports